import linkIcon from "../../../assets/linkExpireIcon.svg"

const LinkExpired = () => {
	return (
		<div className="flex items-center justify-center">
			<div className="max-w-md rounded-xl bg-white p-6 text-center shadow-sm">
				<div className="mb-6 flex items-center justify-center">
					<img src={linkIcon} alt="modern football" />
				</div>
				<h1 className="mb-4 text-3xl font-bold text-gray-800">Link Expired</h1>
				<div className="mb-2 text-center align-middle font-sans text-sm font-normal leading-[22px] tracking-normal text-gray-700">
					The link you followed has expired. It was valid for 48 hours only.
					Please follow below link to create your password.
				</div>
				<div className="mt-5">
					<a
						className="rounded-md bg-blue-600 px-6 py-2 text-sm font-semibold text-white transition hover:bg-blue-700 sm:text-base"
						href="/forgot-password"
					>
						Create Password
					</a>
				</div>
			</div>
		</div>
	)
}

export default LinkExpired
